class PiUatCtaAddToCart extends HTMLElement {
  connectedCallback() {
    if (this._listenerAttached) return;
    this._listenerAttached = true;
    this.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick);
    this._listenerAttached = false;
  }

  /**
   * Same control as the main ATC: first primary in product-buy-buttons, skipping
   * .buy-now-btn and the sticky-cart drawer duplicate.
   */
  _findAddToCartPrimary() {
    const nodes = document.querySelectorAll(
      "product-buy-buttons-element .product-buy-buttons--primary:not(.buy-now-btn)"
    );
    for (let i = 0; i < nodes.length; i++) {
      const btn = nodes[i];
      if (!btn.closest(".product-buy-buttons--drawer")) {
        return btn;
      }
    }
    return nodes[0] || null;
  }

  _handleClick = (event) => {
    const primary = this._findAddToCartPrimary();
    if (!primary || primary.disabled) {
      return;
    }
    event.preventDefault();
    primary.click();
  };
}

if (!customElements.get("pi-uat-cta-add-to-cart")) {
  customElements.define("pi-uat-cta-add-to-cart", PiUatCtaAddToCart);
}
